const validationFields = {
  validationField: ['newPassword', 'repeatPassword'],
};

export default validationFields;
